import { groupBy, sum } from '@s7/utils';
import { useBalance } from '../api/useBalance';
var createUseMilesBalance = function (kind) {
    return useBalance.derive(function (data) {
        return sum.apply(void 0, groupBy(data.balancesContainer, 'type')[kind].map(function (item) { return item.value; }));
    });
};
/** Баланс бонусных миль пользователя */
export var useBonusMilesBalance = createUseMilesBalance('REDEMPTION');
